import { forwardRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";

import { cn } from "@/utils/cn";

export type ScrollContainerProps = {
  className?: string;
  children: React.ReactNode;
};

export const ScrollContainer = forwardRef<HTMLDivElement, ScrollContainerProps>(
  ({ className, children }, ref) => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    if (isMobile) {
      return (
        <div ref={ref} className={cn("overflow-auto", className)}>
          {children}
        </div>
      );
    }

    return (
      <PerfectScrollbar
        // @ts-expect-error it works
        ref={ref}
        className={className}
      >
        {children}
      </PerfectScrollbar>
    );
  }
);
